<i18n src="@/lang/defaults-i18n.yaml"></i18n>
<i18n src="./content-equipment-data-i18n.yaml"></i18n>
<template>
    <v-container fluid py-0 my-0>
        <!-- Rolle des Meldenden auswählen -->
        <v-row no-gutters>
            <v-col cols="12">
                <div class="caption" v-html="$t('role-caption')"></div>
                <base-select
                    v-model="computedRole"
                    :items="roleItems"
                    :error-messages="roleErrors"
                    :label="$t('role-label')"
                    :placeholder="$t('role-placeholder')"
                    :required="isRequiredField($v.role)"
                    dense
                    :item-text="(item) => $t(`task-role-${item.value}`)"
                >
                    <template v-slot:prepend-item>
                        <div
                            class="text-body-1 pl-3"
                            v-html="$t('role-label')"
                        ></div>
                        <v-divider></v-divider>
                    </template>
                </base-select>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { ROLE_TYPES } from "@/data/globals.js";
import validateMixin from "@/mixins/validate";
import { required } from "vuelidate/lib/validators";
export default {
    name: "ContentEquipmentData",
    mixins: [validateMixin],
    props: {
        role: {
            type: String
        }
    },
    validations: {
        role: { required }
    },
    data: () => ({
        roleItems: [
            {
                value: ROLE_TYPES.OPERATOR
            },
            {
                value: ROLE_TYPES.OPERATOR_BEHALF
            }
        ]
    }),
    methods: {
        onFieldChange(field, value) {
            this.$emit("value:change", { field, value });
        }
    },
    computed: {
        computedRole: {
            get() {
                return this.role;
            },
            set(value) {
                this.onFieldChange("role", value);
            }
        },
        roleErrors() {
            const errors = [];
            if (!this.$v.role.$dirty) {
                return errors;
            }
            if (!this.$v.role.required) {
                errors.push(this.$t("field-required"));
            }
            return errors;
        }
    }
};
</script>
